export type DistributionUnits="seconds"|"minutes";
/** Preserve small nonzero durations; clocks and histogram geometry remain in seconds. */
export function formatDistributionDuration(seconds:number,units:DistributionUnits="seconds",digits=2):string {
  const value=units === "minutes"?seconds/60:seconds;
  const text=units === "minutes"?new Intl.NumberFormat("en",{maximumSignificantDigits:3}).format(value)
    :value!==0&&Math.abs(value)<.5*10**-digits?value.toPrecision(2):value.toFixed(digits);
  return `${text} ${units === "minutes"?"min":"s"}`;
}
